// This is responsible for logging, in case we need it

export const logDatabaseWrite = true

let writesInTime = 0 // how many writes have occurred in last `time`
const time = 40 * 1000 // one minute seconds
const threshold = 70 // if 70 writes have occurred in last 40 seconds

function addWrite(amount = 1) {
    // Throttle
    writesInTime = writesInTime + amount
    setTimeout(() => (writesInTime = writesInTime - amount), time)
}

/**
 * I created this because there was some spikes in database activity
 * and I thought maybe I programmed some circular read/write thing in
 * it. This
 * @param docPath
 * @param data
 * @returns
 */
export function logWrite(docPath: string, data: any, info = "") {
    if (logDatabaseWrite) console.log("🖊 " + docPath, data, info)

    addWrite()

    if (writesInTime >= threshold) {
        throw new Error(
            "Uh oh! Looks like too many writes to the database - exceeded " +
                threshold +
                " in " +
                time / 1000 +
                " seconds"
        )
    }
}
